export default "__VITE_ASSET__U9fx7t2s__"